export default "__VITE_ASSET__BeT_yCl9__"